// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/form/post-message/post-message-get-user.scss
// module id = 4727
// module chunks = 50